import { playSound, Sound } from '~/assets/sounds';
import { returnToMain, useLayoutDispatch } from '~/layouts/phone/redux';
import { StyledContainer, StyledWrapper } from './BackButton.styled';

const BackButton = () => {
	const dispatch = useLayoutDispatch();

	return (
		<StyledWrapper
			onClick={() => {
				dispatch(returnToMain());
				playSound(Sound.ClickButton);
			}}
		>
			<StyledContainer onMouseEnter={() => playSound(Sound.LinkCursor)} />
		</StyledWrapper>
	);
};

export { BackButton };
